export const PROMO_CREATIVE = {
  '/home': 'homepage-slider',
  '/': 'homepage-slider',
  '/resources': 'all-about-tires-offer',
  '/regions/mfa': 'regional-page-offers',
  '/deals': 'specials-page-offers'
}
